// extracted by mini-css-extract-plugin
export default {"informationBlock":"InformationBlock_informationBlock__RcU8x","title":"InformationBlock_title__iP1hp","content":"InformationBlock_content__CisKL"};